/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { SampleProfileSchema } from './sampleProfileSchema';

export interface EmployerBucketSchema {
  name: string;
  count: number;
  domain?: string | null;
  sample_profiles?: SampleProfileSchema[];
}
